<template>
    <div>
        <div class="m-search-results" v-infinite-scroll="onScroll" v-if="filteredResults.length">
            <template-card v-for="(item, index) in filteredResults"
                           :key="index"
                           :item="item"
                           :quantity="item.quantity"
                           :showControls="showControls"
                           :isFavourite="isFavourite(item)"
                           @setQuantity="setQuantity"
                           @shareItem="shareItem"
                           @addFavourite="addFavourite(item, index)"
                           @removeFavourite="removeFavourite(item, index)" />
        </div>

        <no-results v-if="!filteredResults.length" />

        <share-modal :visible.sync="shareModalVisible" :url="shareUrl" />
    </div>
</template>

<script>
    import templateCard from "../components/template-card.vue";
    import noResults from "../components/no-results.vue";
    import shareModal from "../modals/share-modal.vue";
    import infiniteScroll from "../directives/infinite-scroll";
    import searchStore from "../stores/search";
    import favouritesStore from "../stores/favourites";

    export default {
        props: {
            keywords: { type: String },
            types: { type: Array },
            categories: { type: Array },
            tags: { type: Array },
            favourites: { type: Boolean },
            customImage: { type: Boolean },
            customText: { type: Boolean },
            editUrl: { type: String },
            showControls: { type: Boolean }
        },
        data: function () {
            return {
                results: [],
                page: 1,
                totalResults: 0,
                // share modal
                shareModalVisible: false,
                shareUrl: null
            };
        },
        watch: {
            $props: {
                handler: function () {
                    this.page = 1;
                    this.results = [];
                    this.performSearch();
                },
                deep: true,
                immediate: true
            }
        },
        computed: {
            filteredResults: function () {
                if (this.favourites) {
                    return this.results.filter(x => this.isFavourite(x));
                } else {
                    return this.results;
                }
            }
        },
        methods: {
            performSearch: function () {
                searchStore.search({
                    page: this.page,
                    keywords: this.keywords,
                    types: this.types,
                    categories: this.categories,
                    tags: this.tags,
                    customImage: this.customImage,
                    customText: this.customText
                })
                .then(res => {
                    this.results = this.results.concat(res.data.results);
                    this.totalResults = res.data.totalResults;
                });
            },
            setQuantity: function (item, quantity) {
                const urlParams = new URLSearchParams(window.location.search);
                const itemId = urlParams.get("itemId");
                if (this.editUrl && itemId) {
                    window.location.href = this.editUrl + '?productId=' + item.id + '&itemId=' + itemId;
                } else {
                    window.location.href = item.url;
                }
            },
            shareItem: function (item) {
                this.shareModalVisible = true;
                this.shareUrl = item.url;
            },
            isFavourite: function (item) {
                return favouritesStore.items.includes(item.id);
            },
            addFavourite: function (item, index) {
                const self = this;
                favouritesStore.add(item.id)
                    .then(res => {
                        self.$set(self.results, index, item);
                    });
            },
            removeFavourite: function (item, index) {
                const self = this;
                favouritesStore.remove(item.id)
                    .then(res => {
                        self.$set(self.results, index, item);
                    });
            },
            onScroll: function () {
                if (this.results.length < this.totalResults) {
                    this.page++;
                    this.performSearch();
                }
            }
        },
        components: {
            templateCard,
            noResults,
            shareModal
        },
        directives: {
            infiniteScroll
        }
    };
</script>